import React from "react";
import { useCombinedStore } from "../store";
import * as AlfredoStyles from "../styles/components/FreeSpace";

const LastOptions: React.FC = () => {
  const { optionsZustand } = useCombinedStore();

  const lastPagesOption = optionsZustand.find(
    (option) => option.optionType === "lastPages"
  );

  return (
    <AlfredoStyles.LastOptionsContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>favorite</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Opções Favoritadas</AlfredoStyles.Title>
      </AlfredoStyles.Card>
    </AlfredoStyles.LastOptionsContainer>
  );
};

export default LastOptions;
